import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useEditVideoMutation } from "../redux/features/videos/videosAPI";

import {
  useEditAssignmentMutation,
  useGetAssignmentsQuery,
} from "../redux/features/assignments/assignmentAPI";

import {
  useEditQuizMutation,
  useGetQuizzesQuery,
} from "../redux/features/quiz/quizAPI";

import {
  useEditQuizMarkMutation,
  useGetQuizMarksQuery,
} from "../redux/features/quiz/quizMarkAPI";
import Error from "./Error";
import { changeDateFormat } from "../utils/dateformatter";

export default function EditVideoForm({ video }) {
  const {
    title: updateTitle,
    description: updateDescription,
    url: updateURL,
    views: updateViews,
    duration: updateDuration,
    createdAt: updateCreatedAt,
    id,
  } = video;

  const navigate = useNavigate();
  const [editVideo, { isLoading, error }] = useEditVideoMutation();

  const { data: assignments } = useGetAssignmentsQuery();
  const [editAssignment] = useEditAssignmentMutation();
  const concernedAssignments = assignments?.filter(
    (assignment) => assignment.video_title === updateTitle
  );

  const { data: quizzes } = useGetQuizzesQuery();
  const [editQuiz] = useEditQuizMutation();

  const concernedQuizzes = quizzes?.filter(
    (quiz) => quiz.video_title === updateTitle
  );

  const { data: quizMarks } = useGetQuizMarksQuery();
  const [editQuizMark] = useEditQuizMarkMutation();

  const concernedQuizMarks = quizMarks?.filter(
    (quiz) => quiz.video_title === updateTitle
  );

  const [title, setTitle] = useState(updateTitle);
  const [description, setDescription] = useState(updateDescription);
  const [url, setUrl] = useState(updateURL);
  const [views, setViews] = useState(updateViews);
  const [duration, setDuration] = useState(updateDuration);
  const [createdAt, setCreatedAt] = useState(changeDateFormat(updateCreatedAt));

  const handleSubmit = (e) => {
    e.preventDefault();

    editVideo({
      id,
      data: {
        title,
        description,
        url,
        views,
        duration,
        createdAt: new Date(createdAt).toISOString(),
      },
    });

    concernedAssignments.forEach((assignment) =>
      editAssignment({
        id: assignment.id,
        data: {
          ...assignment,
          video_title: title,
        },
      })
    );

    concernedQuizzes.forEach((quiz) =>
      editQuiz({
        id: quiz.id,
        data: {
          ...quiz,
          video_title: title,
        },
      })
    );

    concernedQuizMarks.forEach((quizMark) =>
      editQuizMark({
        id: quizMark.id,
        data: {
          ...quizMark,
          video_title: title,
        },
      })
    );

    navigate("/admin/videos");
  };

  return (
    <form className="mt-8 space-y-6" onSubmit={(e) => handleSubmit(e)}>
      <div className="rounded-md shadow-sm -space-y-px">
        <div>
          <label
            htmlFor="title"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            Title
          </label>
          <input
            id="title"
            name="title"
            type="name"
            autoComplete="name"
            required
            className="login-input rounded-md mt-1"
            placeholder="Video Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        <div>
          <label
            htmlFor="description"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white mt-4"
          >
            Description
          </label>
          <input
            id="description"
            name="description"
            type="description"
            autoComplete="description"
            required
            className="login-input rounded-md mt-1"
            placeholder="Video Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <br />

        <div>
          <label
            htmlFor="url"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            URL
          </label>
          <input
            id="url"
            name="url"
            type="url"
            autoComplete="url"
            required
            className="login-input rounded-md mt-1"
            placeholder="Video Url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />
        </div>

        <br />

        <div>
          <label
            htmlFor="Views"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            Views
          </label>
          <input
            id="views"
            name="views"
            type="text"
            autocomplete="views"
            required
            className="login-input rounded-md mt-1"
            placeholder="Views"
            value={views}
            onChange={(e) => setViews(e.target.value)}
          />
        </div>

        <br />

        <div>
          <label
            htmlFor="Duration"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            Duration
          </label>
          <input
            id="duration"
            name="duration"
            type="name"
            autoComplete="duration"
            required
            className="login-input rounded-md mt-1"
            placeholder="Video Duration"
            value={duration}
            onChange={(e) => setDuration(e.target.value)}
          />
        </div>

        <br />

        <div>
          <label
            htmlFor="createdAt"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            Created At
          </label>
          <input
            style={{ colorScheme: "dark" }}
            id="createdAt"
            name="createdAt"
            type="date"
            autoComplete="createdAt"
            required
            className="login-input rounded-md mt-1"
            value={createdAt}
            onChange={(e) => setCreatedAt(e.target.value)}
          />
        </div>
      </div>

      <div className="flex justify-end gap-x-2">
        <button
          type="submit"
          disabled={isLoading}
          className="py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
        >
          Update
        </button>

        <Link
          to="/admin/videos"
          type="submit"
          disabled={isLoading}
          className="py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
        >
          Cancel
        </Link>
      </div>

      {error && <Error message={error.message} />}
    </form>
  );
}
